import React, { useContext, useState } from 'react'
import axios from 'shared/http'
import verifyIsLoginActive from 'util/verifyIsLoginActive'
import { bindActionCreators } from 'redux'
import { setModalShowRedux } from 'store/modal/actions'
import { connect } from 'react-redux'
import LoginBox from 'containers/LoginBox/LoginBox'

import { Styled } from './Navbar.styled'
import { UI } from 'components/UI/UI.styled'

import MenuMobile from 'components/MenuMobile/MenuMobile'
import NavItems from 'components/NavItems/NavItems'
import NavItemsPrivate from 'components/NavItems/NavItemsPrivate'
import NavbarProfile from 'components/NavbarProfile/NavbarProfile'
import NavbarProfilePrivate from 'components/NavbarProfile/NavbarProfilePrivate'
//import NavbarSearch from 'components/NavbarSearch/NavbarSearch'
//import NavbarSearchMobile from 'components/NavbarSearchMobile/NavbarSearchMobile'
import { MenuIcon } from 'components/Icons/Icons'
import Logo from 'components/Logo/Logo'

import { TabContext } from 'components/Tab/Tab'
import { useCount } from 'util/context/Count'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pushDataLayerGTM from 'util/pushDataLayerGTM'
import ModalDocumentValidation from 'components/ModalDocumentValidation'
import { useDocumentValidation } from 'hooks/useDocumentValidation'

const Navbar = ({ showModal, props }) => {
  const [isLoggedIn, setIsLoggedIn] = React.useState({})
  const [showLegal, setShowLegal] = React.useState(false)
  const [ofertaArrasadoras, setOfertaArrasadoras] = React.useState(false)
  const { count, setCount, tabList, setTabList } = useCount()
  const history = useHistory()
  const { handleChangeTab } = useContext(TabContext)

  // Hook para validação de documento - movido para cá para que o modal não feche com o menu mobile
  const {
    showModal: showDocumentModal,
    checkDocumentValidation,
    handleSelectAccountType,
    closeModal: closeDocumentModal,
    isValidating,
    hasMultipleAccountTypes,
    hasNegativeBalance,
  } = useDocumentValidation()
  const [state, setState] = React.useState({
    infoUsuario: [],
    isPerson:
      localStorage.getItem('auth-token') === null
        ? ''
        : JSON.parse(localStorage.getItem('auth-token')).typePerson,
    isVisible: true,
    loadInfo: false,
    showMeusVouchers: false,
  })

  history.listen(async (location, action) => {
    let usuario = verifyIsLoginActive()
    setIsLoggedIn(Boolean(usuario))
    if (Boolean(usuario)) {
      setState({ ...state, isPerson: usuario.typePerson })
    }
    const path = (location?.pathname || '').toLowerCase()
    if (path === '/' || path === '/home') {
      setOfertaArrasadoras(false)
    }
  })

  const [menuOpen, setMenuOpen] = useState(false)

  const handleOpenMenu = () => {
    setMenuOpen(!menuOpen)
  }

  function getInfo() {
    try {
      let usuario = verifyIsLoginActive()

      if (Boolean(usuario)) {
        setIsLoggedIn(usuario)
        setState((prevState) => ({
          ...prevState,
          isPerson: usuario.typePerson,
          loadInfo: true,
        }))
        let url = '/participants/v2/info'
        axios
          .get(url)
          .then((response) => {
            try {
              setState((prevState) => ({ ...prevState, loadInfo: false }))

              const participantes = Array.isArray(response)
                ? response
                : [response]

              const participanteFisica = participantes.find(
                (p) =>
                  p.typePerson === 'Física' ||
                  p.typePerson === 'Physics' ||
                  p.typePerson === 'Fisica'
              )
              const participanteJuridica = participantes.find(
                (p) =>
                  p.typePerson === 'Jurídica' ||
                  p.typePerson === 'Legal' ||
                  p.typePerson === 'Juridica'
              )

              const totalAvaliableBalance = participantes.reduce(
                (sum, p) => sum + (p.avaliableBalance || 0),
                0
              )

              // Prioriza o participante com isActiveProfile: true
              const participanteAtivo = participantes.find(
                (p) => p.isActiveProfile === true
              )

              const participantePrincipal =
                participanteAtivo ||
                participanteFisica ||
                participanteJuridica ||
                participantes[0] ||
                {}

              const infoUsuario = {
                ...participantePrincipal,
                document: participantePrincipal.document || '',
                name: participantePrincipal.name || '',
                typePerson: participantePrincipal.typePerson || '',
                avaliableBalance: totalAvaliableBalance,
                participanteFisica: participanteFisica || null,
                participanteJuridica: participanteJuridica || null,
                firstName: participantePrincipal.name
                  ? participantePrincipal.name.split(' ')[0]
                  : '',
              }

              let usuario = verifyIsLoginActive()
              let showMeusVouchers = Boolean(usuario?.typePerson != 'Legal')

              setState((prevState) => ({
                ...prevState,
                infoUsuario,
                showMeusVouchers,
                loadInfo: false,
              }))
            } catch (error) {
              console.error('Erro ao processar resposta:', error)
              setState((prevState) => ({ ...prevState, loadInfo: false }))
            }
          })
          .catch((error) => {
            console.error('Erro na requisição getInfo:', error)
            setState((prevState) => ({ ...prevState, loadInfo: false }))
            retryNumber = retryNumber + 1
            if (retryNumber === 4) {
              localStorage.removeItem('auth-token')
              setIsLoggedIn(false)
              history.push('/Login')
              setState((prevState) => ({ ...prevState, loadInfo: false }))
            } else {
              setTimeout(() => {
                retry()
                console.log('Erro - Retry ' + retryNumber, '[Erro]', error)
              }, 5000)
            }
          })
      } else {
        setIsLoggedIn(false)
      }
    } catch (error) {
      console.error('Erro geral em getInfo:', error)
      setState((prevState) => ({ ...prevState, loadInfo: false }))
      setIsLoggedIn(false)
    }
  }

  React.useEffect(() => {
    const user = JSON.parse(window.localStorage.getItem('auth-token')) || ''

    if (user?.typePerson === 'Legal') {
      setShowLegal(true)
    }
    getInfo()
    const currentPath = (window.location?.pathname || '').toLowerCase()
    if (currentPath === '/' || currentPath === '/home') {
      setOfertaArrasadoras(false)
    }
    if (currentPath === '/oferta-arrasadoras') {
      setTimeout(() => {
        setOfertaArrasadoras(true)
      }, 1000)
    }
  }, [])

  let retryNumber = 0

  const retry = () => {
    getInfo()
  }

  const handleClickOfertaArrasadoras = () => {
    handleChangeTab(0)
    history.push('/oferta-arrasadoras')
    setOfertaArrasadoras(true)
  }

  return (
    <>
      <Styled.Wrap>
        <UI.Container mobileFull>
          <Styled.Nav>
            <Styled.MobileMenuButton
              style={{ cursor: 'pointer' }}
              onClick={handleOpenMenu}
            >
              <MenuIcon />
            </Styled.MobileMenuButton>
            <Styled.Logo>
              <Styled.LogoWrap>
                <Logo />
              </Styled.LogoWrap>

              <Styled.NavItems>
                {isLoggedIn ? (
                  <NavItemsPrivate
                    isPerson={state.isPerson}
                    showMeusVouchers={state.showMeusVouchers}
                    checkDocumentValidation={checkDocumentValidation}
                  />
                ) : (
                  <NavItems />
                )}
              </Styled.NavItems>
            </Styled.Logo>
            <Styled.Profile status={isLoggedIn}>
              {/* <Styled.Search>
                <NavbarSearch />
                <NavbarSearchMobile />
              </Styled.Search> */}
              {isLoggedIn ? (
                <NavbarProfilePrivate
                  infoUsuario={state.infoUsuario}
                  loadInfo={state.loadInfo}
                />
              ) : (
                <NavbarProfile />
              )}
            </Styled.Profile>
          </Styled.Nav>

          <Styled.MenuNav>
            <Styled.ButtonLink
              className={`${count == 1 ? 'active' : ''}`}
              onClick={() => {
                const category = 'home'
                const action = 'clique:header'
                const label = 'trocar-pontos'
                const additionalData = { position: 'header' }
                pushDataLayerGTM(category, action, label, additionalData)
                setOfertaArrasadoras(false)
                handleChangeTab(1)
              }}
            >
              <strong>Trocar Pontos</strong>
            </Styled.ButtonLink>
            <Styled.ButtonLink
              hidden={showLegal}
              className={`${count == 2 ? 'active' : ''}`}
              onClick={() => {
                // Taguamento GTM para menu header
                const category = 'home'
                const action = 'clique:header'
                const label = 'comprar-com-desconto'
                const additionalData = { position: 'header' }
                pushDataLayerGTM(category, action, label, additionalData)
                setOfertaArrasadoras(false)
                handleChangeTab(2)
              }}
            >
              Comprar com <strong> desconto</strong>
            </Styled.ButtonLink>
            {/* <Styled.ButtonLink
              hidden={showLegal}
              className={`${count == 3 ? 'active' : ''}`}
              onClick={() => {
                // Taguamento GTM para menu header
                const category = 'home'
                const action = 'clique:header'
                const label = 'comprar-e-ganhar-pontos'
                const additionalData = { position: 'header' }
                pushDataLayerGTM(category, action, label, additionalData)
                handleChangeTab(3)
              }}
            >
              Comprar e <strong> ganhar pontos</strong>
            </Styled.ButtonLink> */}
          </Styled.MenuNav>
        </UI.Container>

        <MenuMobile
          open={menuOpen}
          setMenuOpen={handleOpenMenu}
          infoUsuario={state.infoUsuario}
          loadInfo={state.loadInfo}
          isPerson={state.isPerson}
          checkDocumentValidation={checkDocumentValidation}
        />
      </Styled.Wrap>

      {/* Modal de validação de documento - renderizado aqui para não fechar com o menu mobile */}
      {showDocumentModal && (
        <ModalDocumentValidation
          onClose={closeDocumentModal}
          onSelectAccountType={handleSelectAccountType}
          isValidating={isValidating}
          hasMultipleAccountTypes={hasMultipleAccountTypes}
          hasNegativeBalance={hasNegativeBalance}
        />
      )}

      <Styled.ProfileMobile>
        {isLoggedIn ? (
          <div
            style={{
              padding: '0px 20px',
              background: '#DBF1FF',
            }}
          >
            <NavbarProfilePrivate
              infoUsuario={state.infoUsuario}
              loadInfo={state.loadInfo}
              type={'menubar'}
            />
          </div>
        ) : (
          ''
        )}
      </Styled.ProfileMobile>
    </>
  )
}

const dispatch = (dispatch) =>
  bindActionCreators({ showModal: setModalShowRedux }, dispatch)

export default connect(null, dispatch)(Navbar)
